(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-blocks"] && !Shopify.designMode) return;
  try {
    
class TabsComponent extends HTMLElement {
  static HEADER_HEIGHT = 73;
  static MOBILE_BREAKPOINT = 750;
  static DEBOUNCE_TIMING = 250;

  constructor() {
    super();
    this.videoLoadStates = new Map();
    this.hlsInstances = new Map();
    
    // Add resize listener
    this.handleResize = this.debounce(() => {
      this.updateLayout();
    }, TabsComponent.DEBOUNCE_TIMING);
    
    window.addEventListener('resize', this.handleResize);
    
    this.initializeComponent();
  }

  initializeComponent() {
    try {
        this.validateAttributes();
        this.cacheElements();
        this.setupAccessibility();
        this.createComponentStructure();
        this.setupEventHandlers();
        this.updateLayout();
        this.validateActiveStates(); // Add this line
    } catch (error) {
        console.error('TabsComponent error:', error);
    }
  }

  validateAttributes() {
    ['data-right-arrow', 'data-up-arrow', 'data-close'].forEach(attr => {
      if (!this.hasAttribute(attr)) {
        throw new Error(`Missing required attribute: ${attr}`);
      }
    });
  }

  cacheElements() {
    this.elements = {
      tabItems: this.querySelectorAll('.tabs__item'),
      videoGridContainer: document.createElement('div'),
      stickyNavContainer: document.createElement('nav'),
      toggleButton: null,
      backToTopButton: null
    };

    if (!this.elements.tabItems.length) {
      throw new Error('No tab items found');
    }
  }

  setupAccessibility() {
    // First remove any existing active states
    this.elements.tabItems.forEach(tab => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-hidden', 'true');
    });

    this.elements.tabItems.forEach((tab, index) => {
        tab.id = tab.id || `tab-${index}`;
        tab.setAttribute('role', 'tabpanel');
        tab.setAttribute('aria-labelledby', `tab-button-${index}`);
        tab.setAttribute('aria-hidden', index !== 0);
        
        // Only set the first tab as active
        if (index === 0) {
            tab.classList.add('is-active');
        }
    });
  }

  setupEventHandlers() {
    this.handleScroll = this.debounce(() => {
      const isSticky = window.scrollY > this.offsetTop;
      this.elements.stickyNavContainer.classList.toggle('is-sticky', isSticky);
      
      if (this.elements.backToTopButton) {
        this.elements.backToTopButton.classList.toggle('is-visible', isSticky);
      }
    }, 75);
  
    this.handleBackToTop = () => {
      const headerOffset = TabsComponent.HEADER_HEIGHT * 2.5;
      const targetPosition = this.elements.videoGridContainer.offsetTop - headerOffset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    };

    window.addEventListener('scroll', this.handleScroll);
    if (this.elements.backToTopButton) {
      this.elements.backToTopButton.addEventListener('click', this.handleBackToTop);
    }
  }

  createComponentStructure() {
    this.setupVideoGrid();
    this.setupStickyNav();
    const backToTopButton = this.createBackToTopButton();
    this.querySelector('.tabs__items').appendChild(backToTopButton);
  }

  createBackToTopButton() {
    const button = document.createElement('button');
    button.className = 'tabs__back-to-top';
    button.setAttribute('aria-label', 'Back to top');
    button.setAttribute('type', 'button');
    
    const icon = document.createElement('img');
    icon.src = this.getAttribute('data-up-arrow');
    icon.alt = '';
    icon.setAttribute('aria-hidden', 'true');
    
    button.appendChild(icon);
    this.elements.backToTopButton = button;
    return button;
  }

  setupVideoGrid() {
    this.elements.videoGridContainer.className = 'tabs__video-grid';
    this.elements.videoGridContainer.setAttribute('role', 'presentation');
    
    const fragment = document.createDocumentFragment();
    this.elements.tabItems.forEach((tab, index) => {
      const videoContainer = this.createVideoContainer(tab, index);
      fragment.appendChild(videoContainer);
    });
    
    this.elements.videoGridContainer.appendChild(fragment);
    
    const itemsContainer = this.querySelector('.tabs__items');
    if (itemsContainer) {
      this.insertBefore(this.elements.videoGridContainer, itemsContainer);
    }
  }

  createVideoContainer(tab, index) {
    const container = document.createElement('div');
    container.className = 'tabs__video-container';

    const videoPreview = this.createVideoPreview(tab, index);
    const nameElement = this.createNameElement(tab);
    
    container.append(videoPreview, nameElement);
    return container;
  }

  createNameElement(tab) {
    const nameElement = document.createElement('div');
    nameElement.className = 'tabs__video-name h3';
    nameElement.textContent = tab.dataset.tabName;
    return nameElement;
  }

  createVideoPreview(tab, index) {
    const preview = document.createElement('div');
    preview.className = 'tabs__video-preview';
    preview.setAttribute('role', 'button');
    preview.setAttribute('aria-label', `Show ${tab.dataset.tabName}`);
    
    const { video, coverImage } = this.createMediaElements(tab);
    this.setupVideoBehavior(preview, video, index);
    
    preview.append(coverImage, video);
    return preview;
  }

  createMediaElements(tab) {
    const processUrl = url => url?.startsWith('//') ? `https:${url}` : url;
    
    // Check for mobile-specific image
    const isMobile = window.innerWidth < TabsComponent.MOBILE_BREAKPOINT;
    const coverImageSrc = isMobile && tab.dataset.tabMobileImage 
      ? processUrl(tab.dataset.tabMobileImage) 
      : processUrl(tab.dataset.tabVideoCover);
  
    const coverImage = document.createElement('img');
    coverImage.className = 'tabs__video-preview-image';
    coverImage.alt = tab.dataset.tabName;
    coverImage.loading = 'lazy';
    coverImage.src = coverImageSrc;
  
    const video = document.createElement('video');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    video.className = 'tabs__video';
    video.style.cssText = 'width:100%;height:100%;object-fit:cover';
    
    this.setupVideoSource(video, processUrl(tab.dataset.tabVideo));
    return { video, coverImage };
  }

  setupVideoBehavior(preview, video, index) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.loadVideo(video);
    }, { rootMargin: '50px' });
    observer.observe(preview);

    preview.addEventListener('click', () => this.switchTab(index, true));
    preview.addEventListener('mouseenter', () => video.play().catch(console.debug));
    preview.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });
  }

  setupVideoSource(video, url) {
    if (url.includes('.m3u8')) {
      this.handleHlsVideo(video, url);
    } else {
      video.dataset.videoUrl = url;
    }
  }

  async handleHlsVideo(video, url) {
    if (typeof Hls === 'undefined') {
      await this.loadHlsLibrary();
    }
    this.initHls(video, url);
  }

  loadHlsLibrary() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  initHls(video, url) {
    if (Hls.isSupported()) {
      const hls = new Hls({ enableWorker: true, lowLatencyMode: true });
      hls.attachMedia(video);
      hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(url));
      this.hlsInstances.set(video, hls);
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = url;
    }
  }

  async loadVideo(video) {
    if (this.videoLoadStates.get(video)) return;
    
    try {
      const wrapper = video.closest('.tabs__video-preview');
      if (wrapper) wrapper.classList.add('is-loading');

      if (!video.src && video.dataset.videoUrl) {
        video.src = video.dataset.videoUrl;
      }
      
      await video.play();
      this.videoLoadStates.set(video, true);
    } catch (error) {
      console.error('Video load failed:', error);
      this.videoLoadStates.set(video, false);
    } finally {
      const wrapper = video.closest('.tabs__video-preview');
      if (wrapper) wrapper.classList.remove('is-loading');
    }
  }

  setupStickyNav() {
    const nav = this.elements.stickyNavContainer;
    nav.className = 'tabs__sticky-nav';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Product categories');

    nav.append(
      this.createSpacer('left'),
      this.createNavItems(),
      this.createToggleButton(),
      this.createSpacer('right')
    );
    
    this.insertBefore(nav, this.querySelector('.tabs__items'));
    this.setupNavInteractions();
  }

  createSpacer(side) {
    const spacer = document.createElement('div');
    spacer.className = `tabs__nav-spacing--${side}`;
    return spacer;
  }

  createNavItems() {
    const container = document.createElement('div');
    container.className = 'tabs__nav-icons';
    
    this.elements.tabItems.forEach((tab, index) => {
      const button = document.createElement('button');
      // Add the is-active class to the first item (index 0)
      button.className = `tabs__nav-item${index === 0 ? ' is-active' : ''}`;
      button.id = `tab-button-${index}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', index === 0);
      button.setAttribute('aria-controls', tab.id);
      button.setAttribute('data-index', index);
      
      const icon = document.createElement('img');
      icon.src = this.processUrl(tab.dataset.tabIcon);
      icon.alt = '';
      icon.setAttribute('aria-hidden', 'true');
      
      button.appendChild(icon);
      button.addEventListener('click', () => this.switchTab(index, true));
      container.appendChild(button);
    });
    
    return container;
  }

  processUrl(url) {
    return url?.startsWith('//') ? `https:${url}` : url;
  }

  createToggleButton() {
    const button = document.createElement('button');
    button.className = 'tabs__nav-toggle';
    button.setAttribute('aria-label', 'Toggle navigation');
    
    const arrowImage = document.createElement('img');
    arrowImage.className = 'tabs__nav-arrow';
    arrowImage.src = this.getAttribute('data-right-arrow');
    arrowImage.alt = '';
    
    button.appendChild(arrowImage);
    return button;
  }

  setupNavInteractions() {
    const nav = this.elements.stickyNavContainer;
    const toggle = nav.querySelector('.tabs__nav-toggle');
    const arrowImage = toggle.querySelector('img');

    toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const expanded = nav.classList.toggle('is-expanded');
        arrowImage.src = expanded ? this.getAttribute('data-close') : this.getAttribute('data-right-arrow');
    });
    
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) {
        nav.classList.remove('is-expanded');
        arrowImage.src = this.getAttribute('data-right-arrow');
      }
    });

    // Keyboard navigation
    nav.addEventListener('keydown', (e) => {
      const target = e.target.closest('.tabs__nav-item');
      if (!target) return;

      const currentIndex = parseInt(target.dataset.index);
      let newIndex;

      switch (e.key) {
        case 'ArrowLeft': newIndex = currentIndex - 1; break;
        case 'ArrowRight': newIndex = currentIndex + 1; break;
        case 'Home': newIndex = 0; break;
        case 'End': newIndex = this.elements.tabItems.length - 1; break;
        default: return;
      }

      if (newIndex >= 0 && newIndex < this.elements.tabItems.length) {
        e.preventDefault();
        this.switchTab(newIndex, true);
      }
    });
  }

  validateActiveStates() {
    const activeTabItems = Array.from(this.elements.tabItems).filter(tab => 
        tab.classList.contains('is-active')
    );
    
    const activeNavItems = Array.from(
        this.elements.stickyNavContainer.querySelectorAll('.tabs__nav-item')
    ).filter(item => item.classList.contains('is-active'));

    // If we have no active items or multiple active items, reset to the first item
    if (activeTabItems.length !== 1 || activeNavItems.length !== 1) {
        this.switchTab(0, false);
        return false;
    }
    return true;
  }

  debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  switchTab(newIndex, shouldFocus = false) {
    const oldIndex = this.currentActiveIndex;
    if (newIndex === oldIndex || newIndex < 0 || newIndex >= this.elements.tabItems.length) return;

    // First, remove active state from all tabs to prevent multiple active states
    this.elements.tabItems.forEach((tab, index) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-hidden', 'true');
    });

    const navItems = this.elements.stickyNavContainer.querySelectorAll('.tabs__nav-item');
    navItems.forEach(item => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
    });

    // Then set the new active states
    this.elements.tabItems[newIndex].classList.add('is-active');
    this.elements.tabItems[newIndex].setAttribute('aria-hidden', 'false');
    navItems[newIndex].classList.add('is-active');
    navItems[newIndex].setAttribute('aria-selected', 'true');

    // Scroll active tab into view on mobile
    if (window.innerWidth < TabsComponent.MOBILE_BREAKPOINT) {
        navItems[newIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    }

    // Preload next video
    const nextIndex = (newIndex + 1) % this.elements.tabItems.length;
    const nextVideo = this.elements.tabItems[nextIndex]?.querySelector('video');
    if (nextVideo) this.loadVideo(nextVideo);

    // Focus management
    if (shouldFocus) {
        navItems[newIndex].focus({ preventScroll: true });
    }

    // Scroll positioning
    const headerHeight = TabsComponent.HEADER_HEIGHT;
    const targetScroll = this.elements.stickyNavContainer.offsetTop - headerHeight;
    if (window.scrollY < targetScroll) {
        window.scrollTo({
            top: targetScroll,
            behavior: 'smooth'
        });
    }
  }

  get currentActiveIndex() {
    return Array.from(this.elements.tabItems).findIndex(t => t.classList.contains('is-active'));
  }

  updateLayout() {
    const isMobile = window.innerWidth < TabsComponent.MOBILE_BREAKPOINT;
    this.elements.videoGridContainer?.classList.toggle('is-mobile', isMobile);
    
    // Optionally, re-create media elements when layout changes
    this.elements.tabItems.forEach((tab, index) => {
      const videoContainer = this.querySelector(`.tabs__video-container:nth-child(${index + 1})`);
      if (videoContainer) {
        const existingPreview = videoContainer.querySelector('.tabs__video-preview');
        if (existingPreview) {
          existingPreview.remove();
        }
        const newPreview = this.createVideoPreview(tab, index);
        videoContainer.appendChild(newPreview);
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.elements.backToTopButton) {
      this.elements.backToTopButton.removeEventListener('click', this.handleBackToTop);
    }
    this.hlsInstances.forEach(hls => hls.destroy());
  }
}

customElements.define('tabs-component', TabsComponent);

  } catch(e) { console.error(e); }
})();
})();
